import flatpickr from 'flatpickr'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fromField", "toField"]

  connect() {
    const that = this;
    
    flatpickr(this.inputTarget, {
      mode: "range",
      altInput: true,
      altFormat: "M j, Y",
      dateFormat: "Y-m-d",
      onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length === 2) {
          // Format dates as YYYY-MM-DD
          const fromDate = selectedDates[0].toISOString().split('T')[0];
          const toDate = selectedDates[1].toISOString().split('T')[0];
          
          // Update hidden fields
          that.fromFieldTarget.value = fromDate;
          that.toFieldTarget.value = toDate;
          
          // Submit form
          that.inputTarget.form.requestSubmit();
        }
      },
      onClose: function(selectedDates, dateStr, instance) {
        // Clear if only one date selected
        if (selectedDates.length === 1) {
          instance.clear();
          that.fromFieldTarget.value = '';
          that.toFieldTarget.value = '';
          that.inputTarget.form.requestSubmit();
        }
      }
    });
    
    // Set initial value if both fields have values
    if (this.fromFieldTarget.value && this.toFieldTarget.value) {
      this.inputTarget.value = `${this.fromFieldTarget.value} to ${this.toFieldTarget.value}`;
    }
  }
}
